import {Guide} from '@blesk-frontend/api';
import {getPrivateAxios} from '../../libs';

/**
 *
 * @param guide
 */
export const fetchGuideDelete = async (guide: Pick<Guide, 'id'>) => {
  const {data} = await getPrivateAxios().delete<void>(`/guides/${guide.id}`);
  return data;
};
